.carouselViewport {
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 343 / 240;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  border-radius: 24px;
}

.carouselTrack {
  position: relative;
  white-space: nowrap;

  /* slide transition; component sets inline transition:none for the clone snap */
  transition: transform 0.3s;
  height: 100%;
  display: flex;
  align-items: center;
}

@media (prefers-reduced-motion: reduce) {
  .carouselTrack {
    transition: none;
  }
}

@media all and (--reefer-media-tablet-min) {
  /* tablet+ widens to Boost's shared 1312/320 band; height is aspect-ratio-driven
     at every size (no max-height cap), matching the legacy carousel. */
  .carouselViewport {
    aspect-ratio: 1312 / 320;
  }
}
